<template>
  <div style="display: inline-block">
    <b-button
      variant="outline-secondary"
      size="sm"
      :class="buttonClass"
      :disabled="disabled || isExecuting"
      pill
      @click="executeDefer"
    >
      <b-spinner v-if="isExecuting" small></b-spinner>
      <span v-else>보류</span>
    </b-button>
  </div>
</template>

<script>
import { approvalPool } from "../apis/index.js";

export default {
  name: "DeferButton",
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: "resultBtn"
    }
  },
  data() {
    return {
      isExecuting: false
    };
  },
  methods: {
    buildHeaders() {
      return { Authorization: this.$session.get("token") };
    },
    buildCountryParams() {
      const country = this.$session.get("country");
      if (typeof country === "string" && country.length > 0) {
        return { country };
      }
      return {};
    },
    async executeDefer() {
      this.isExecuting = true;
      try {
        const response = await approvalPool.updateUserApproval(
          {
            id: this.userId,
            approvalAction: approvalPool.APPROVAL_ACTIONS.DEFER
          },
          this.buildCountryParams(),
          this.buildHeaders()
        );
        this.$toast.success("보류로 이동했습니다.", {
          position: "top",
          duration: 2000,
        });
        this.$emit("action-success", {
          userId: this.userId,
          response
        });
      } catch (error) {
        console.error("Failed to defer user:", error);
        this.$toast.error("보류 처리 중 오류가 발생했습니다.", {
          position: "top",
          duration: 2000,
        });
        this.$emit("action-error", {
          userId: this.userId,
          error
        });
      } finally {
        this.isExecuting = false;
      }
    }
  }
};
</script>

<style scoped>
.resultBtn {
  margin: 5px 10px 0px 10px;
  word-break: keep-all;
  word-wrap: normal;
}
</style>
